export enum authCredentialType {
  EMAIL = 1,
  DOCUMENT = 2,
}
